import React from 'react';
import '../assets/css/About.css';
import myStoryImage from '../assets/images/my-story-learning.svg';
import myStoryAfaanOromo from '../assets/images/my-story-afaan-oromo.svg';

const About = () => {
  return (
    <div className="about-page">
      {/* About Header */}
      <div className="about-header">
        <div className="container">
          <h1>About Learning Oromo</h1>
          <p>Dedicated to making Oromo language learning accessible, engaging, and effective for everyone</p>
        </div>
      </div>

      {/* About Content */}
      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img src={myStoryAfaanOromo} alt="Learning Afaan Oromo" className="large-image" />
            </div>
            <div className="about-text">
              <h2>My Story</h2>
              <p>Learn Oromo: My name is Abdula Siraj my mission to provide and  
                create a platform where anyone can learn the Oromo language in an engaging and effective way. As one of the most widely spoken languages in Ethiopia and parts of Kenya, Oromo has rich cultural significance and practical importance.</p>
              <p>I believe that language learning should be accessible to everyone, regardless of their background or previous experience with languages. That's why I have designed YouTube videos easy to follow and adaptable to different learning styles and paces.</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* My Story with Learning Image */}
      <section className="about-content my-story-section">
        <div className="container">
          <div className="about-grid">
            <div className="about-image">
              <img src={myStoryImage} alt="Learning Oromo" className="large-image" />
            </div>
            <div className="about-text">
              <h2>Learning Journey</h2>
              <p>The journey of learning Oromo is filled with discovery and cultural enrichment. 
                My approach combines traditional language learning methods with modern interactive techniques to make the process engaging and effective.</p>
              <p>Whether you're a complete beginner or looking to improve your existing skills, my structured learning path guides you through vocabulary, grammar, pronunciation, and cultural context at a pace that works for you.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="container">
          <div className="section-title">
            <h2>Mission & Vision</h2>
            <p>What drives me forward</p>
          </div>
          <div className="mission-vision-grid">
            <div className="mission">
              <h3>Mission</h3>
              <p>To preserve and promote the Oromo language by providing accessible, high-quality language education to learners worldwide. 
                I strive to create an engaging learning environment that respects the cultural context of the language while using modern educational techniques.</p>
            </div>
            <div className="vision">
              <h3>Our Vision</h3>
              <p>To become the leading platform for Oromo language learning, connecting people across the globe through language and cultural understanding. 
                I envision a world where language barriers are reduced, and the rich heritage of the Oromo people is celebrated and preserved for future generations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Learning Approach */}
      <section className="section">
        <div className="container">
          <div className="section-title">
            <h2>My Learning Approach</h2>
            <p>How I make language learning effective</p>
          </div>
          <div className="features">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Cognitive Science</h3>
              <p>understanding curriculum is based on proven cognitive science principles that optimise how your brain acquires and retains new language skills.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-sync-alt"></i>
              </div>
              <h3>Spaced Repetition</h3>
              <p>I try to present content at optimal intervals, ensuring you remember what you've learned for the long term.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-user-graduate"></i>
              </div>
              <h3>Personalised Learning</h3>
              <p> Adaptive system adjusts to your learning pace and style, focusing more on areas where you need additional practice.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section" style={{ backgroundColor: '#f0f4f8' }}>
        <div className="container">
          <div className="section-title">
            <h2>Join Our Learning Community</h2>
            <a href="https://youtube.com/@teachoromoolanguagebydr.ab4564" target="_blank" rel="noopener noreferrer" className="btn-primary">Explore My YouTube channel</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;